
  export default {
    props: {
      id: {
        default: '',
        type: String,
      },
      primary: {
        default: 'dark',
        type: String,
      },
      secondary: {
        default: 'white',
        type: String,
      },
      rounded: {
        default: 'tr',
        type: String,
      },      
      center: {
        default: 'false',
        type: String,
      },
      padding: {
        default: '!pt-10 !pb-10',
        type: String,
      }
    },
    render() {
      const slot = this.$slots.default
      //  return slot.text.replace(/,/g, "")
      return slot
    },
  
  }
  